import { render, staticRenderFns } from "./ViewHeader.vue?vue&type=template&id=dc590c72&scoped=true&"
import script from "./ViewHeader.vue?vue&type=script&lang=js&"
export * from "./ViewHeader.vue?vue&type=script&lang=js&"
import style0 from "./ViewHeader.vue?vue&type=style&index=0&id=dc590c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc590c72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
